import templateGenerator from '../utils/template-generator';

export default {
   render: function(preRollSrc) {
      return templateGenerator.generatePreRollMarkup(preRollSrc);
   }
};
